import { memo } from 'react';
import { Text, Heading, VStack } from '@library';
import ProductAttributeSelector from '../ProductTileView/ProductAttributeSelector';
import type { ProductItem } from '../../types';
import stripHtml from '../../../core/util/stripHtml';
import CurrentStoreLink from '../../../core/components/router/CurrentStoreLink';
import useTabletView from '../../../core/hooks/dom/useTabletView';
import styles from './ProductListView.module.scss';

const ProductListViewSummary = ({
    product,
    activeSKU,
    productDetailsLink,
    setActiveSKU,
}: {
    product: ProductItem;
    activeSKU?: string;
    productDetailsLink: string;
    setActiveSKU: (sku: string) => void;
}) => {
    const { name, summary, tileAttributes: tileAttributesOrNull } = product;
    const tileAttributes = tileAttributesOrNull || [];
    const { variants } = product;

    const isTabletView = useTabletView();

    const attributeSummaryText =
        tileAttributes.length > 0 && stripHtml(tileAttributes[0].value);
    const attributeSummary = isTabletView ? (
        <Text tertiary medium uppercase>
            {attributeSummaryText}
        </Text>
    ) : (
        <Text caption uppercase>
            {attributeSummaryText}
        </Text>
    );
    return (
        <VStack gap="small" align="start">
            <div>
                <CurrentStoreLink
                    to={productDetailsLink}
                    className={styles.productName}
                >
                    <Heading h5 bold>
                        {name}
                    </Heading>
                </CurrentStoreLink>
                <div className={styles.productSummaryText}>
                    <Text
                        secondary={isTabletView}
                        tertiary={!isTabletView}
                        regular
                    >
                        <span
                            /* eslint-disable-next-line react/no-danger */
                            dangerouslySetInnerHTML={{
                                __html: summary,
                            }}
                        />
                    </Text>
                </div>
            </div>
            {attributeSummaryText && (
                <div className={styles.featuredAttribute}>
                    {attributeSummary}
                </div>
            )}
            {variants.length > 0 && (
                <div className={styles.attributesContainer}>
                    <ProductAttributeSelector
                        grayBg={!isTabletView}
                        variants={variants}
                        onAttributeSelected={setActiveSKU}
                        selectedVariantSKU={activeSKU}
                        mobile={isTabletView}
                    />
                </div>
            )}
        </VStack>
    );
};

export default memo(ProductListViewSummary);
